
[
  {
    "id": "TG-E8-L305-001",
    "module": "TijdGeld",
    "difficulty": 305,
    "question": "Wat kost een auto van € 20.000 na 3 jaar afschrijving van 10% per jaar?",
    "options": ["€ 14.580", "€ 14.000", "€ 15.000", "€ 16.000"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "rente",
    "familyId": "TG-AFSCHRIJVING",
    "explanation": "J1: 18.000. J2: 16.200. J3: 16.200 - 1.620 = 14.580.",
    "distractorExplanations": { "1": "3 x 2000 eraf.", "2": "Schattingsfout.", "3": "2 jaar." }
  },
  {
    "id": "TG-E8-L305-002",
    "module": "TijdGeld",
    "difficulty": 305,
    "question": "Hoeveel minuten per dag ben je kwijt aan tandenpoetsen (2x 2 min) in een jaar?",
    "options": ["1460 minuten", "730 minuten", "1000 minuten", "2000 minuten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TG-TANDEN",
    "explanation": "4 min/dag x 365 = 1460.",
    "distractorExplanations": { "1": "2 min/dag.", "2": "Schattingsfout.", "3": "Schattingsfout." }
  },
  {
    "id": "TG-E8-L305-003",
    "module": "TijdGeld",
    "difficulty": 305,
    "question": "Bruto loon € 2000. Belasting 35%. Wat is netto?",
    "options": ["€ 1300", "€ 1400", "€ 700", "€ 1650"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "loon",
    "familyId": "TG-BRUTO-NETTO",
    "explanation": "35% van 2000 = 700. 2000 - 700 = 1300.",
    "distractorExplanations": { "1": "30% eraf.", "2": "Dat is de belasting.", "3": "Schattingsfout." }
  },
  {
    "id": "TG-E8-L305-004",
    "module": "TijdGeld",
    "difficulty": 305,
    "question": "Je rijdt 120 km/u. Je moet 300 km. Hoe lang duurt het?",
    "options": ["2 uur 30 min", "2 uur 50 min", "3 uur", "2 uur 40 min"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-REISTIJD",
    "explanation": "300 : 120 = 2,5 uur = 2 uur 30 min.",
    "distractorExplanations": { "1": "Schattingsfout.", "2": "Schattingsfout.", "3": "Schattingsfout." }
  },
  {
    "id": "TG-E8-L305-005",
    "module": "TijdGeld",
    "difficulty": 305,
    "question": "Wat is 0,5% van € 40.000?",
    "options": ["€ 200", "€ 2000", "€ 20", "€ 400"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "rente",
    "familyId": "TG-PROC-KLEIN",
    "explanation": "1% = 400. 0,5% = 200.",
    "distractorExplanations": { "1": "Dat is 5%.", "2": "Dat is 0,05%.", "3": "Dat is 1%." }
  }
]
